// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/capability/v1/capability_links.proto (package mono.capability.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddCapabilityProofRequest, AddCapabilityProofResponse, LinkCapabilityToRequirementRequest, LinkCapabilityToRequirementResponse, ListCapabilityProofsRequest, ListCapabilityProofsResponse, ListCapabilityRequirementLinksRequest, ListCapabilityRequirementLinksResponse, RemoveCapabilityProofRequest, RemoveCapabilityProofResponse, SearchCapabilityLinkTargetsRequest, SearchCapabilityLinkTargetsResponse, UnlinkCapabilityRequirementRequest, UnlinkCapabilityRequirementResponse } from "./capability_links_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Browser surface owned by zou (REG-46 placement override). Pangaea's internal
 * gateway owns authorization, visibility and transactional audit. Identity is
 * supplied by sabaody, never by these messages.
 *
 * @generated from service mono.capability.v1.CapabilityLinkService
 */ export const CapabilityLinkService = {
    typeName: "mono.capability.v1.CapabilityLinkService",
    methods: {
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.LinkCapabilityToRequirement
     */ linkCapabilityToRequirement: {
            name: "LinkCapabilityToRequirement",
            I: LinkCapabilityToRequirementRequest,
            O: LinkCapabilityToRequirementResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.UnlinkCapabilityRequirement
     */ unlinkCapabilityRequirement: {
            name: "UnlinkCapabilityRequirement",
            I: UnlinkCapabilityRequirementRequest,
            O: UnlinkCapabilityRequirementResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.ListCapabilityRequirementLinks
     */ listCapabilityRequirementLinks: {
            name: "ListCapabilityRequirementLinks",
            I: ListCapabilityRequirementLinksRequest,
            O: ListCapabilityRequirementLinksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.SearchCapabilityLinkTargets
     */ searchCapabilityLinkTargets: {
            name: "SearchCapabilityLinkTargets",
            I: SearchCapabilityLinkTargetsRequest,
            O: SearchCapabilityLinkTargetsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.AddCapabilityProof
     */ addCapabilityProof: {
            name: "AddCapabilityProof",
            I: AddCapabilityProofRequest,
            O: AddCapabilityProofResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.RemoveCapabilityProof
     */ removeCapabilityProof: {
            name: "RemoveCapabilityProof",
            I: RemoveCapabilityProofRequest,
            O: RemoveCapabilityProofResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityLinkService.ListCapabilityProofs
     */ listCapabilityProofs: {
            name: "ListCapabilityProofs",
            I: ListCapabilityProofsRequest,
            O: ListCapabilityProofsResponse,
            kind: MethodKind.Unary
        }
    }
};
